import { observer } from 'mobx-react';

import { CameraInitialSetup } from '../../../3dEngine/threejs/Camera';
import ThreejsScene from '../../../3dEngine/threejs/ThreejsScene';
import { VisualizationFull3dState } from '../../VisualizationFull3dState';

export interface VisualizationFull3dProps {
  state: VisualizationFull3dState;
  className: string;
}

const VisualizationFull3d = ({ state }: VisualizationFull3dProps) => {
  const cameraSetup: CameraInitialSetup = {
    position: [2, 1.2, 3],
    target: [0, 0.6, 0],
    zoom: 2,
    minDistance: 1,
    maxDistance: 10,
  };

  return (
    <ThreejsScene
      state={state.sceneState}
      freeze={true}
      showPerformance={false}
      onNoneObjectClick={() => {
        // do nothing
      }}
      onObjectClick={() => {
        // do nothing
      }}
      cameraSetup={cameraSetup}
      enableAO={true}
    />
  );
};

export default observer(VisualizationFull3d);
